var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row-v2",attrs:{"id":"vtv-show"}},[_vm._m(0),_c('div',{staticClass:"col right"},[_c('div',{staticClass:"col__box"},[_c('vtv-channels-component')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col left"},[_c('div',{staticClass:"col__box"})])
}]

export { render, staticRenderFns }